export default (timestamp, separator) => {
    let _date = new Date(timestamp*1)
    return `${_date.getFullYear()}${separator || '年'}${_date.getMonth() + 1 < 10 ? `0${_date.getMonth() + 1}` : _date.getMonth() + 1}${separator || '月'}${_date.getDate() < 10 ? `0${_date.getDate()}` : _date.getDate()}${separator || '日'}`
}